import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const REMINDER_TYPE = {
  PAYMENT: 0,
  DELIVERY: 1,
  GUARANTOR: 2,
  GUARANTOR_PAYMENT: 3,
  ADMINISTRATIVE_PROCEEDING: 4,
  GUARANTOR_ADMINISTRATIVE_PROCEEDING: 5
}

export const REMINDER_TYPE_MAP = {
  0: t('constants.reminder_type.payment'),
  1: t('constants.reminder_type.delivery'),
  2: t('constants.reminder_type.guarantor'),
  3: t('constants.reminder_type.guarantor_payment'),
  4: t('constants.reminder_type.administrative_proceeding'),
  5: t('constants.reminder_type.guarantor_administrative_proceeding')
}

export const REMINDERS = {
  PAYMENT_REMINDER_BEFORE_7_DAYS: 1,
  PAYMENT_REMINDER_BEFORE_1_DAYS: 2,
  DELIVERY_REMINDER: 3,
  GUARANTOR_CONFIRMATION: 4
}

export const REMINDER_PHONE_SURVEY_TYPE = {
  SEVEN_DAYS_BEFORE_PAYMENT: 0,
  ONE_DAY_BEFORE_PAYMENT: 1,
  DELIVERY_CONFIRMATION: 2,
  GUARANTOR_CONFIRMATION: 3,
  GUARANTOR_SEVEN_DAYS_BEFORE_PAYMENT: 4,
  GUARANTOR_ONE_DAY_BEFORE_PAYMENT: 5,
  ADMINISTRATIVE_PROCEEDING: 6,
  GUARANTOR_ADMINISTRATIVE_PROCEEDING: 7
}
